import { Action } from '@ngrx/store';
import { ApplicationConfiguration, Permission, MenuItem, SystemContent } from '@model';
import { UserType } from '@enums';

export enum ConfigurationActionTypes {
  LoadApiConfiguration = '[Configuration] Load ApiConfiguration',
  LoadApiConfigurationSuccess = '[Configuration] Load ApiConfiguration success',
  LoadApiConfigurationFail = '[Configuration] Load ApiConfiguration fail',
  AuthSetupComplete = '[Configuration] Auth Setup Complete',
  SetActiveClient = '[Configuration] Set Active Client',

  LoadMenuConfiguration = '[Configuration] Load MenuConfiguration',
  LoadMenuConfigurationSuccess = '[Configuration] Load MenuConfiguration success',
  LoadMenuConfigurationFail = '[Configuration] Load MenuConfiguration fail',

  LoadSystemContent = '[Configuration] Load SystemContent',
  LoadSystemContentSuccess = '[Configuration] Load SystemContent success',
  LoadSystemContentFail = '[Configuration] Load SystemContent fail',

  LoadPermission = '[Configuration] Load Permissions',
  LoadPermissionSuccess = '[Configuration] Load Permissions success',
  LoadPermissionFail = '[Configuration] Load Permissions fail',
  ClearPermission = '[Configuration] Clear Permissions',

  SetErrorRefreshPerformed = '[Configuration] Refresh on error'
}

export class ApiConfigurationLoad implements Action {
  readonly type = ConfigurationActionTypes.LoadApiConfiguration;
  constructor() {}
}

export class ApiConfigurationLoadSuccess implements Action {
  readonly type = ConfigurationActionTypes.LoadApiConfigurationSuccess;
  constructor(public payload: ApplicationConfiguration) {}
}

export class ApiConfigurationLoadFail implements Action {
  readonly type = ConfigurationActionTypes.LoadApiConfigurationFail;
  constructor(public payload: any) {}
}

export class SetActiveClient implements Action {
  readonly type = ConfigurationActionTypes.SetActiveClient;
  constructor(public payload: string) {}
}

export class AuthSetupComplete implements Action {
  readonly type = ConfigurationActionTypes.AuthSetupComplete;
  constructor() {}
}

export class LoadPermission implements Action {
  readonly type = ConfigurationActionTypes.LoadPermission;
  constructor() {}
}

export class LoadPermissionSuccess implements Action {
  readonly type = ConfigurationActionTypes.LoadPermissionSuccess;
  constructor(public payload: Permission[]) {}
}

export class LoadPermissionFail implements Action {
  readonly type = ConfigurationActionTypes.LoadPermissionFail;
  constructor(public payload: any) {}
}

export class ClearPermission implements Action {
  readonly type = ConfigurationActionTypes.ClearPermission;
  constructor() {}
}

export class MenuConfigurationLoad implements Action {
  readonly type = ConfigurationActionTypes.LoadMenuConfiguration;
  constructor() {}
}

export class MenuConfigurationLoadSuccess implements Action {
  readonly type = ConfigurationActionTypes.LoadMenuConfigurationSuccess;
  constructor(public payload: MenuItem[]) {}
}

export class MenuConfigurationLoadFail implements Action {
  readonly type = ConfigurationActionTypes.LoadMenuConfigurationFail;
  constructor(public payload: any) {}
}

export class SystemContentLoad implements Action{
  readonly type = ConfigurationActionTypes.LoadSystemContent;
  constructor(){}
}

export class SystemContentLoadSuccess implements Action{
  readonly type = ConfigurationActionTypes.LoadSystemContentSuccess;
  constructor(public payload: SystemContent){}
}

export class SystemContentLoadFail implements Action{
  readonly type = ConfigurationActionTypes.LoadSystemContentFail;
  constructor(public payload: any){}
}



export class ErrorRefreshPerformed implements Action {
  readonly type = ConfigurationActionTypes.SetErrorRefreshPerformed;
  constructor() {}
}

export type ConfigurationActions =
  | ApiConfigurationLoad
  | ApiConfigurationLoadSuccess
  | ApiConfigurationLoadFail
  | AuthSetupComplete
  | SetActiveClient
  | LoadPermission
  | LoadPermissionFail
  | LoadPermissionSuccess
  | ClearPermission
  | MenuConfigurationLoad
  | MenuConfigurationLoadSuccess
  | MenuConfigurationLoadFail
  | SystemContentLoad
  | SystemContentLoadSuccess
  | SystemContentLoadFail
  | ErrorRefreshPerformed;
